<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>
                                <img src="assets/images/credits_icon.png" alt="icon" style="width: 15px;margin-right: 5px;" />TrinkaのTrinkaトークン</h1>
                            <h2>Trinkaトークンを使って
                                必要な機能をフル活用
                            </h2>
                            <p>ご利用プランに応じて毎月無料で付与されるポイントを、Trinkaの5つの便利な機能にご利用いただけます。
                            </p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/CreditInformation.png" alt="credit info" class="md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="cloud_key_features section-pd pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaトークンで必要な機能を活用</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_feature">
                        <table class="table">
                            <thead>
                                <tr class="odd">
                                    <th>機能</th>
                                    <th class="text-center">
                                        <sup>
                                            <img style="width: 20px;" src="assets/images/credits_icon.png" alt="credits icon" />
                                        </sup>利用ポイント数
                                    </th>
                                </tr>
                            </thead>
                            <tr>
                                <td>
                                    <h5>Trinka盗用・剽窃レポート</h5>
                                    <p>iThenticate® を使用した、インターネットソースやオープンアクセス出版物との比較による高品質の盗用・剽窃チェックを行います。
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">1レポートあたり24ポイント使用
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>iThenticate® 盗用・剽窃レポート</h5>
                                    <p>
                                        iThenticate® を使用した、インターネット、オープンアクセス、有料出版物との比較による高品質の盗用・剽窃チェックを行います。
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">1レポートあたり36ポイント使用
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>自動ファイル校正</h5>
                                    <p>MS Wordファイルを数分で自動校正。すべての修正箇所を記録した変更履歴を含む校正済みファイルをダウンロードできます。
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">5000単語ごとに1ポイント
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>出版適正チェック</h5>
                                    <p>ジャーナルとの相性から、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで英文を査定し、論文受理の可能性を高めます。

                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">レポート1件ごとに1ポイント
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <h5>引用チェック</h5>
                                    <p>研究の前提や論拠を弱めかねない引用を識別し、論文に信頼性の高い文献を引用できるようにします。
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">1ポイントで最大10文献をチェック
                                    </p>
                                </td>
                            </tr>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="creadits_availability section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaトークンの有効期限</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>ユーザーの皆様には、1か月ごとにご利用プランに応じた無料ポイントをプレゼント。未使用ポイントは1か月で失効しリセットされます。</p>
                        <p>必要に応じ追加ポイントの購入も可能です。ご購入いただくポイントに有効期限はありません。ポイントパックについて、詳しくは
                            <a (click)="scroll(target)" class="remove-left-space">こちら</a>をご覧ください。
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>
                            <sup>
                                <img style="width: 22px;" src="assets/images/credits_icon.png" />
                            </sup> Credits Availability</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin: 0;">All Trinka users get free credits every 30 days. Unused credits lapse and are reset every 30 days.</p>
                        <p>Purchase additional credits when you need. Purchased credits never expire. To know more about credit
                            packs,
                            <a  (click)="scroll(target)">click here.</a>
                        </p>
                    </div>
                </div> -->
                <div class="col-lg-3 col-sm-6">
                    <div class="creaditsCardSection first">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>ベーシック</h2>
                                <span>無料</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>4</h3>
                                <p>1か月ごとに付与されるポイント数</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="creaditsCardSection">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>プレミアム</h2>
                                <span>有料</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>10</h3>
                                <p>1か月ごとに付与されるポイント数</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="creaditsCardSection">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>プレミアムプラス</h2>
                                <span>有料</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>20</h3>
                                <p>1か月ごとに付与されるポイント数</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="creaditsCardSection">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>機密データ保護プラン</h2>
                                <span>有料</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>50</h3>
                                <p>1か月ごとに付与されるポイント数</p>
                            </div>
                        </div>
                    </div>
                </div>
                

            </div>
        </div>
    </div>

    <div class="how_it_works section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title text-center">
                        <h2>Trinkaトークン付与の仕組み</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>1月5日にベーシックプランにご登録いただいた場合を例にあげてご説明します。
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">例1</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">日にち</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">項目</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">失効／消費</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">付与／購入</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">ポイント残高</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>アカウント開設時の無料ポイント</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>ファイル自動校正で1ポイント消費</td>
                                        <td style="color: red;">-1</td>
                                        <td></td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>1か月ごとの無料ポイント失効／追加</td>
                                        <td style="color: red;"></td>
                                        <td style="color: green;">+4</td>
                                        <td>4</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">例2
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">日にち</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">項目</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">失効／消費</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">付与／購入</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">ポイント残高</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>アカウント開設時の無料ポイント</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>ファイル自動校正で2ポイント消費</td>
                                        <td style="color: red;">-2</td>
                                        <td></td>
                                        <td>2</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>追加ポイント4ポイント購入</td>
                                        <td></td>
                                        <td style="color: green;">+4</td>
                                        <td>6</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>無料クレジット残高のリセット（無料4回＋有料4回） *</td>
                                        <td></td>
                                        <td style="color: green;">+4</td>
                                        <td>8</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">例3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">日にち</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">項目</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">失効／消費</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">付与／購入</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">ポイント残高</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>アカウント開設時の無料ポイント</td>
                                        <td></td>
                                        <td></td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>追加ポイント4ポイント購入</td>
                                        <td></td>
                                        <td style="color: green;">+4</td>
                                        <td>14</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>ファイル自動校正で4ポイント消費</td>
                                        <td style="color: red;">-4</td>
                                        <td></td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>無料クレジット残高のリセット（無料10回＋有料4回） *</td>
                                        <td></td>
                                        <td style="color: green;">+14</td>
                                        <td>14</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="credit_balance section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>ポイント残高（Credit Balance）と消費数の確認方法</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="assets/images/features/credits/credits-banner1.webp" alt="trinka credits" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>ポイント残高の確認と追加ポイントの購入</h3>
                                <p>ポイント残高は関連ページすべてに表示されます。ポイント残高をクリックすると、詳細ページに移り、そこから追加ポイントの購入も可能です。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="assets/images/features/credits/credits-banner2.webp" alt="credits banner" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>各機能利用に必要なポイント</h3>
                                <p>ポイントが必要なTrinkaの機能を利用する場合、必要なポイント数は、事前に明示されます。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="buying-credit section-pd" #target>
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaトークンの購入</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>追加Trinkaトークンは、必要に応じてご購入いただけます。</p>
                        <p>購入ポイントは永久不滅。４／8／２０/40ポイントをまとめてご購入いただくお得なパック割引がおすすめです。なお、1か月ごとに自動で追加される無料ポイントは、つねに購入ポイントに優先して消費されるので便利です。</p>
                    </div>
                    <div class="credit_pack">
                        <div class="buyCreditTable table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="font-size: 21px;color: #000000; font-weight: bold;">ポイント・パック （Credit Packs）</th>
                                        <th style="font-size: 21px;color: #000000; font-weight: bold;">
                                            <span>ベーシック</span>
                                            <br />
                                        </th>
                                        <th style="font-size: 21px;color: #000000; font-weight: bold;">Premium</th>
                                    </tr>
                                </thead>
                                <tr>
                                    <td style="font-size: 18px;color: #4d4d4d; font-weight: 600;">無料の自動付与ポイント（Credits）</td>
                                    <td>4ポイント/月<br/>
                                        <small class="sm-small-content">（4Credits/Month）</small></td>
                                    <td>10ポイント/月<br/>
                                        <small class="sm-small-content"> （10Credits/Month）</small></td>
                                </tr>
                                <tr>
                                    <td style="font-size: 18px;color: #4d4d4d; font-weight: 600;">2ポイント・パック<br/>({{decodedData[0].text}})</td>
                                    <td><sup style="font-size: 13px">{{decodedData[0].currency_code}}</sup> {{decodedData[0].final_amount / 2 | number:'1.2-2'}} <i>per credit</i></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[0].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[0].currency_code}}</sup> {{calculatePlan(premiumDecodedData[0].final_amount, premiumDecodedData[0].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[0].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 18px;color: #4d4d4d; font-weight: 600;">8ポイント・パック<br/>({{decodedData[1].text}})</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[1].currency_code}}</sup> {{calculatePlan(decodedData[1].final_amount, decodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[1].final_amount, decodedData[1].months)}}% off</span>
                                            <i>{{decodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[1].currency_code}}</sup> {{calculatePlan(premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}% off</span>
                                            <i>{{premiumDecodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 18px;color: #4d4d4d; font-weight: 600;">20ポイント・パック<br/>({{decodedData[2].text}})</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[2].currency_code}}</sup> {{calculatePlan(decodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[2].final_amount, decodedData[2].months)}}% off</span>
                                            <i>{{decodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[2].currency_code}}</sup> {{calculatePlan(premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}% off</span>
                                            <i>{{premiumDecodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 18px;color: #4d4d4d; font-weight: 600;">40ポイント・パック<br/>({{decodedData[3].text}})</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[3].currency_code}}</sup> {{calculatePlan(decodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{decodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[3].currency_code}}</sup> {{calculatePlan(premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="section-pd" #target>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaトークンの購入</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>クレジットパックは必要な時にいつでも購入できます。クレジットパックを購入すると、一度に複数のクレジットを入手でき、いつでも利用できます。</p>
                        <p>購入したクレジットに有効期限はありません。さらに、お得な割引も適用されます！しかも、無料のクレジットが常に優先的に自動的に使用されます！
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="freeCreditsSections">
                        <!-- <span class="bg-border"></span> -->
                        <div class="pricetable table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>ポイント・パック （Credit Packs）</th>
                                        <th>ベーシック</th>
                                        <th>プレミアム</th>
                                        <th>プレミアムプラス</th>
                                        <th>機密データ保護プラン</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>無料の自動付与ポイント（Credits）</td>
                                        <td class="fs-coloum">4</td>
                                        <td class="fs-coloum">10</td>
                                        <td class="fs-coloum">20</td>
                                        <td class="fs-coloum">50</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            4ポイント・パック<br/>
                                            (4-credit pack)
                                        </td>
                                        <td>
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{decodedData[0].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(decodedData[0].final_amount, decodedData[0].months).whole }}<small>.{{ calculatePlanST(decodedData[0].final_amount, decodedData[0].months).decimal }}</small>
                                                    </h3>
                                                    <!-- <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 2}}</del></span> -->
                                                </div>
                                                <i>per credit</i>
                                            </div>
                                        </td>
                                        <td colspan="3">
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{premiumDecodedData[0].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(premiumDecodedData[0].final_amount, premiumDecodedData[0].months).whole }}<small>.{{ calculatePlanST(premiumDecodedData[0].final_amount, premiumDecodedData[0].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~40% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="calculateDiscountINR(decodedData[0].amount, premiumDecodedData[0].final_amount, premiumDecodedData[0].months) > 0">~{{calculateDiscountINR(decodedData[0].amount, premiumDecodedData[0].final_amount, premiumDecodedData[0].months)}}% off</span> -->
                                                
                                            </div>
                                        </td>
                                        
                                    </tr>

                                    <tr>
                                        <td>
                                            16ポイント・パック<br/>
                                            (16-credit pack)
                                        </td>
                                        <td>
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{decodedData[0].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(decodedData[1].final_amount, decodedData[1].months).whole }}<small>.{{ calculatePlanST(decodedData[1].final_amount, decodedData[1].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~25% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="decodedData[1].discount > 0">~{{decodedData[1].discount}}% off</span> -->
                                                 
                                            </div>
                                        </td>
                                        <td colspan="3">
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{premiumDecodedData[1].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(premiumDecodedData[1].final_amount, premiumDecodedData[1].months).whole }}<small>.{{ calculatePlanST(premiumDecodedData[1].final_amount, premiumDecodedData[1].months).decimal }}</small>
                                                    </h3>
                                                   <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                   <span class="discount">~55% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="calculateDiscountINR(decodedData[0].amount, premiumDecodedData[1].final_amount, premiumDecodedData[1].months) > 0">~{{calculateDiscountINR(decodedData[0].amount, premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}% off</span> -->
                                                
                                            </div>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>
                                            40ポイント・パック<br/>
                                            (40-credit pack)
                                        </td>
                                        <td>
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{decodedData[0].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(decodedData[2].final_amount, decodedData[2].months).whole }}<small>.{{ calculatePlanST(decodedData[2].final_amount, decodedData[2].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~35% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="decodedData[1].discount > 0">~{{decodedData[1].discount}}% off</span> -->
                                                
                                            </div>
                                        </td>
                                        <td colspan="3">
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{premiumDecodedData[1].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(premiumDecodedData[2].final_amount, premiumDecodedData[2].months).whole }}<small>.{{ calculatePlanST(premiumDecodedData[2].final_amount, premiumDecodedData[2].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~61% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="calculateDiscountINR(decodedData[0].amount, premiumDecodedData[2].final_amount, premiumDecodedData[2].months) > 0">~{{calculateDiscountINR(decodedData[0].amount, premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}% off</span> -->
                                                
                                            </div>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>
                                            80ポイント・パック<br/>
                                            (80-credit pack)
                                        </td>
                                        <td>
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{decodedData[0].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(decodedData[3].final_amount, decodedData[3].months).whole }}<small>.{{ calculatePlanST(decodedData[3].final_amount, decodedData[3].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~40% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="decodedData[1].discount > 0">~{{decodedData[1].discount}}% off</span> -->
                                                 
                                            </div>
                                        </td>
                                        <td colspan="3">
                                            <div class="amount">
                                                <div class="amt_div">
                                                    <b>{{premiumDecodedData[1].currency_code}}</b>
                                                    <h3>
                                                        {{ calculatePlanST(premiumDecodedData[3].final_amount, premiumDecodedData[3].months).whole }}<small>.{{ calculatePlanST(premiumDecodedData[3].final_amount, premiumDecodedData[3].months).decimal }}</small>
                                                    </h3>
                                                    <span><del>{{decodedData[0].currency}}{{decodedData[0].final_amount / 4}}</del></span>
                                                    <span class="discount">~64% off</span>
                                                </div>
                                                <i>per credit</i>
                                                <!-- <span class="discount" *ngIf="calculateDiscountINR(decodedData[0].amount, premiumDecodedData[3].final_amount, premiumDecodedData[3].months) > 0">~{{calculateDiscountINR(decodedData[0].amount, premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}% off</span> -->
                                                 
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">組織・企業向けTrinkaポイント</h3>
                        <p class="text-white mt-20">Trinka Enterpriseでは、チーム単位、組織単位でのポイントのご購入も可能です。ポイントの分配方法や大量購入についても柔軟に対応させていただきます。</p>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a [routerLink]="['/enterprise']" routerLinkActive="active" class="white-btn">問い合わせる</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            購入したポイントのキャンセル・返金はできますか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ、購入ポイントの払い戻しはできません。購入したポイントは、使用されるまでユーザーのアカウントに残ります。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">プレミアムプランにアップグレードすると、無料ポイントはどうなりますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>ベーシックプランからプレミアムプランにアップグレードした段階で、保有していた無料ポイントの有無にかかわらず、無料ポイントの残高は10になります。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            プレミアムプランにアップグレードすると、ベーシックプランで購入していたポイントはどうなりますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>購入ポイントはアップグレード後もそのままアカウントに残り、必要な時にご利用いただけます。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            購入するポイント数に上限はありますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ、購入できるポイントに上限はありません。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>